import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./../styles.css";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/data")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);

const HealthCareIM = () => {
  // const titleString = "Toiletries Indenpendents Market <br /> (-16.1% YoY)";
  const chartOptions = {
    chart: {
      type: "bar",
      backgroundColor: "none",
    },
    credits: {
      enabled: false,
    },
    bar: {
      groupPadding: 0,
      pointPadding: 0,
      dataLabels: {
        enabled: true,
      },
    },
    title: {
      // text: titleString,
      align: "center",
      x: 0,
      y: 10,
    },
    colors: ["rgba(18, 68, 130, 1)"],
    tooltip: {
      enabled: false,
    },
    legend: { enabled: false },
    column: { stacking: "percent" },
    xAxis: {
      categories: [
        "Adult Pain £44.4m",
        "Allergy & Hayfever £4.5m",
        "Body Health £764k",
        "Children's Medicines £13.3m",
        "Cough, Cold & Flu £33.4m",
        "Digestive Health £16.6m",
        "First Aid £3.0m",
        "NRT £271k",
        "Sexual Wellbeing £6.2m",
        "Sleep Aids £186k",
      ],
      title: false,
      labels: {
        enabled: false,
      },
    },
    yAxis: {
      title: false,
      tickInterval: 10,
      min: 0,
      max: 100,
    },
    plotOptions: {
      series: {
        pointHeight: 25,
      },
      bar: {
        borderWidth: 0,
        groupPadding: 0,
        pointPadding: 0.1,
        color: "#2581C4",
        dataLabels: {
          style: {
            textOutline: false,
            fontWeight: 500,
          },
          color: "#092f50",
          enabled: true,
          x: 0,
          formatter: function () {
            return this.x + " " + `(${this.y}%)`;
          },
        },
      },
    },
    series: [
      {
        enableMouseTracking: false,
        showInLegend: false,
        grouping: false,
        color: "lightgray",
        data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
        dataLabels: {
          enabled: false,
        },
      },
      {
        data: [36, 4, 1, 11, 27, 14, 2, 0.2, 5, 0.2],
      },
    ],
  };

  return (
    <div id='container'>
      <HighchartsReact
        containerProps={{ style: { height: "100%" } }}
        highcharts={Highcharts}
        options={chartOptions}
      />
    </div>
  );
};

export default HealthCareIM;
